import { Heading, Badge, Tooltip, Chip } from '@enterprise-ui/canvas-ui-react'
import { useLocation } from 'react-router-dom'
import { VIEWS } from './constants'
import { useState } from 'react'
import EnterpriseIcon, { MailIcon, CloudAlertIcon } from '@enterprise-ui/icons'
import { useAnnouncementNotifications } from '../../hooks/useAnnouncementNotifications'
import { AnnouncementModal } from '../Announcements/AnnouncementModal'
import { useMaintenanceModeCheck } from '../../hooks/useMaintenanceModeCheck'

export const LocationHeader = () => {
  const location = useLocation()
  const { isMaintenanceMode } = useMaintenanceModeCheck()
  const [isAnnouncementModalOpen, setIsAnnouncementModalOpen] = useState(false)

  const { currentViewAnnouncements, hasCurrentViewAnnouncements } =
    useAnnouncementNotifications()

  // Check if we're in one of the shipment management views that should show announcements
  const isInShipmentManagementView =
    location.pathname.includes('/shipment-management/merch-vendor') ||
    location.pathname.includes('/shipment-management/consolidator') ||
    location.pathname.includes('/shipment-management/reverse-logistics')

  let viewTitle = ''
  if (location.pathname.includes(VIEWS.DASHBOARD.path)) {
    viewTitle = VIEWS.DASHBOARD.title
  } else if (location.pathname.includes(VIEWS.SHIPMENT_MANAGEMENT.path)) {
    viewTitle = VIEWS.SHIPMENT_MANAGEMENT.title
  } else if (location.pathname.includes(VIEWS.TRANSPORTATION_PROFILE.path)) {
    viewTitle = VIEWS.TRANSPORTATION_PROFILE.title
  } else if (location.pathname.includes(VIEWS.FAQ.path)) {
    viewTitle = VIEWS.FAQ.title
  } else if (location.pathname.includes(VIEWS.FEATURE_UPVOTE.path)) {
    viewTitle = VIEWS.FEATURE_UPVOTE.title
  }

  return (
    <>
      <Heading className="hc-pa-none hc-ws-no-wrap" size={5}>
        {viewTitle}{' '}
        {isInShipmentManagementView && hasCurrentViewAnnouncements ? (
          <Tooltip location="right" content="Announcements">
            <Badge
              location="top-right"
              content={currentViewAnnouncements.length.toString()}
              color="error"
              onClick={() => setIsAnnouncementModalOpen(true)}
              aria-label={`${currentViewAnnouncements.length} active announcements`}
            >
              <span
                className="animate-wiggle"
                style={{ cursor: 'pointer' }}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    setIsAnnouncementModalOpen(true)
                  }
                }}
              >
                <EnterpriseIcon
                  icon={MailIcon}
                  size="lg"
                  style={{
                    color: '#df6e28ff',
                  }}
                />
              </span>
            </Badge>
          </Tooltip>
        ) : isInShipmentManagementView ? (
          <EnterpriseIcon
            icon={MailIcon}
            size="lg"
            style={{
              color: '#6c757d',
              marginLeft: '8px',
              fontSize: '20px',
            }}
          />
        ) : null}
        {isMaintenanceMode && (
          <Tooltip
            location="bottom"
            content="System is in maintenance mode -some features are disabled"
          >
            <Chip
              color="alert"
              size="dense"
              className="hc-ml-sm animate-pulse"
              style={{ cursor: 'help' }}
            >
              <EnterpriseIcon
                icon={CloudAlertIcon}
                size="sm"
                className="hc-mr-xs"
              />
              Maintenance Mode
            </Chip>
          </Tooltip>
        )}
      </Heading>

      <AnnouncementModal
        announcements={currentViewAnnouncements}
        isOpen={isAnnouncementModalOpen}
        onClose={() => setIsAnnouncementModalOpen(false)}
      />
    </>
  )
}
